import { useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileLines } from "@fortawesome/pro-duotone-svg-icons";
import { useTranslation } from 'react-i18next';
import React from 'react';

function FormStatus({ agent }) {
    const { t } = useTranslation();
    const text = !agent.formOpen ? t("formclosed") : (!agent.formOpenAlarm ? t("formopened") : t("formopenedalarm"));

    const statusIcon = useMemo(() => {
        let ret = <FontAwesomeIcon className="px-1 text-muted" size="lg" icon={faFileLines} />;
        if (agent.formOpen)
            ret = <FontAwesomeIcon className={`px-1 text-${agent.formOpenAlarm ? "danger" : "warning"}`} size="lg" icon={faFileLines} />;
        return ret;
    }, [agent.formOpen, agent.formOpenAlarm]);

    return (
        <div title={text} style={{ display: "inline-block" }}>
            {statusIcon}
        </div>
    );
}

export default FormStatus;